<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { settingApi, importApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
  props: {
    purchaseDataList: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      file: null,
      exportData: [], // 存放上传的excel文件的数据
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: 'SPUR.STOCKIN_GOODS_IMPORT',
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, res.content[0].templateFileName);
          });
      });
    },
    importFile(file) {
      this.exportData = [];
      const _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function () {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        for (const v of Object.values(outData)) {
            // eslint-disable-next-line no-prototype-builtins
            if (v.hasOwnProperty('货号\nITEM#') && (v['货号\nITEM#']).trim() && v.hasOwnProperty('采购单号\nSELLO PO NO') && v.hasOwnProperty('数量\nQTY.') && v.hasOwnProperty('单价\nU.P.')) {
                    const obj = {
                      'skuCode': v['货号\nITEM#'],
                      'planQty': v['数量\nQTY.'],
                      'taxUnitPrice': v['单价\nU.P.'],
                      'code': v['采购单号\nSELLO PO NO']
                    };
                    _this.exportData.push(obj);
                  }
            }
      };
    },
    confirm() {
      if (this.purchaseDataList.length > 0 && this.exportData.length > 0) {
        const differentItems = this.$lodash.differenceBy(this.exportData, this.purchaseDataList, 'code', 'skuCode');
        if (differentItems.length) return this.$message.error(this.$t('BusinessPurchaseComponentsPur.exportHint'));
        this.exportData.forEach(item1 => {
          this.purchaseDataList.forEach(item2 => {
              if (item1.skuCode === item2.skuCode && item1.code === item2.code) {
                item2.temporaryQty = item1.planQty;
                item2.taxUnitPrice = item1.taxUnitPrice;
              }
          });
        });
        this.hide();
        setTimeout(() => {
          this.$emit('submit', this.purchaseDataList);
        }, 500);
      } else if (this.exportData.length === 0) {
        this.msgError(this.$t('WarehouseManagement.form.msgErrorText'));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
